import { authFetch } from "~/services/fetch";

export async function makeRequestTogetReportAllUSers({ agencyIds, groupId, activeInLast, exportCSV = false }) {
  try {
    const response = await authFetch({
      url: '/report/all-users',
      method: 'POST',
      data: {
        active_in_last: activeInLast,
        group_id: groupId,
        agency_ids: agencyIds,
        export_csv: exportCSV
      }
    });

    return response.data;

  } catch (error) {
    console.error('ERROR GENERATE REPORT', error)
    throw error
  }
}